export default __webpack_public_path__ + "static/media/j_wdt_c_0.378b3387.mp3";